import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SALES_SERVICES } from "../../data/salesServicesData";
import Hero from "../../components/medical/Hero";
import ServiceDetailContent from "../../components/ServiceDetailContent";

/** Pathname to service id (from SALES_SERVICES) */
const PATH_TO_SERVICE_ID = {
  "/sales/sales-klassisch": "sales-klassisch",
  "/sales/sales-industrie": "sales-industrie",
  "/sales/sales-healthcare": "sales-healthcare",
};

export default function SalesServiceDetailPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const serviceId = PATH_TO_SERVICE_ID[location.pathname];
  const service = serviceId
    ? SALES_SERVICES.find((s) => s.id === serviceId)
    : null;

  if (!service) {
    return (
      <div className="container-app py-16 text-center">
        <p className="text-gray-600">Seite nicht gefunden.</p>
        <button
          type="button"
          onClick={() => navigate("/sales")}
          className="mt-4 text-gray-900 underline"
        >
          Zur Startseite
        </button>
      </div>
    );
  }

  return (
    <>
      <Hero
        title={service.title}
        subheading={service.heroSubheading || service.desc}
      />
      <section className="bg-white pt-0 pb-16 md:pb-24">
        <ServiceDetailContent
          service={service}
          onClose={() => navigate("/sales")}
          sectionIdPrefix="service"
        />
      </section>
    </>
  );
}
